import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { ButtonLink } from '../components/ButtonLink';
import { PrincipleList } from '../components/PrincipleList';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { candidatePrinciples } from '../data/about';
export function Candidates() {
  return <>
      <PageHero breadcrumb="For Candidates" title="Your next leadership chapter, explored in confidence." lead="We build long-term relationships with senior leaders — sharing honest perspective on opportunities, markets, and career moves." data-id="element-230" data-mp="1gtqhswjwwncp">
        <div className="flex flex-wrap gap-4" data-id="element-231" data-mp="1308y9br87amo">
          <ButtonLink to="/contact?type=candidate" withArrow data-id="element-232" data-mp="1zix4svrqo14b">
            Introduce Yourself
          </ButtonLink>
          <ButtonLink to="/opportunities" variant="outlineDark" data-id="element-233" data-mp="1urf0pyuf5kf4">
            View Leadership Opportunities
          </ButtonLink>
        </div>
      </PageHero>

      <section className="bg-ivory" data-id="element-234" data-mp="1cstc7wdvcqwr">
        <div className="mx-auto max-w-site px-6 py-24 lg:px-10 lg:py-32" data-id="element-235" data-mp="1hptgq2v2lllr">
          <h2 className="max-w-2xl font-serif text-4xl text-midnight-900 md:text-5xl" data-id="element-236" data-mp="130x926wxealo">How we engage with leaders</h2>
          <div className="mt-12" data-id="element-237" data-mp="17yyswu26edy7">
            <PrincipleList items={candidatePrinciples} columns={4} data-id="element-238" data-mp="17y5uqhha8wro" />
          </div>
        </div>
      </section>

      <section className="bg-champagne-50" data-id="element-239" data-mp="u224ez9j58kh">
        <div className="mx-auto grid max-w-site gap-12 px-6 py-24 lg:grid-cols-12 lg:items-center lg:px-10 lg:py-32" data-id="element-240" data-mp="yzlj20a53ncy">
          <Reveal className="lg:col-span-6" data-id="element-241" data-mp="k2ur2c2spdxd">
            <LockIcon className="h-6 w-6 text-champagne-600" aria-hidden="true" data-id="element-242" data-mp="k45wegbw2tql" />
            <h2 className="mt-5 font-serif text-4xl leading-tight text-midnight-900 md:text-5xl" data-id="element-243" data-mp="p14n0owcgik1">Most senior mandates are never advertised.</h2>
          </Reveal>
          <Reveal delay={0.06} className="lg:col-span-5 lg:col-start-8" data-id="element-244" data-mp="2jduhp8ujdvsh">
            <p className="text-[17px] leading-relaxed text-midnight-900/75" data-id="element-245" data-mp="2hxgqgii50spj">
              Many of the roles we fill are confidential — successions, new strategic positions, or replacements not yet announced.
              Introducing yourself means we can consider you when the right opportunity arises, without you ever applying publicly.
            </p>
            <Link to="/opportunities" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-midnight-900 underline decoration-champagne-500 underline-offset-[6px]" data-id="element-246" data-mp="23zs3n54ifbhu">
              See current opportunities
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-247" data-mp="2vrhhsr6rfdfv" />
            </Link>
          </Reveal>
        </div>
      </section>

      <CtaBand title="Start a confidential conversation." lead="Share your background and ambitions. We’ll respond personally and handle every detail in confidence." data-id="element-248" data-mp="2mxmiw0w8ej8o" />
    </>;
}